
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { FileText, Save } from "lucide-react";

export function ContratoTemplateDialog() {
  const [template, setTemplate] = useState(`
CONTRATO DE PROTEÇÃO DE SISTEMA FOTOVOLTAICO
SUNSERVICE PROTEÇÃO LTDA.

CONTRATANTE: [NOME_CLIENTE]
CPF: [CPF_CLIENTE]
ENDEREÇO: [ENDERECO_CLIENTE]

DADOS DO SISTEMA PROTEGIDO:
- Quantidade de Módulos: [QTD_MODULOS]
- Potência Total: [POTENCIA_TOTAL]
- Tipo de Cobertura: [TIPO_PLANO]

COBERTURA CONTRATADA:
✓ Danos por vendaval
✓ Danos por granizo  
✓ Danos elétricos (raios)
✓ Explosão
[COBERTURA_ADICIONAL]

VALOR: [VALOR_CONTRATO]
VIGÊNCIA: 12 meses a partir de [DATA_INICIO]

Assinatura: ________________________
          [NOME_CLIENTE]
`);

  const salvarTemplate = () => {
    // Aqui você pode implementar a lógica para salvar o template
    console.log("Template salvo:", template);
    alert("Template de contrato salvo com sucesso!");
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2">
          <FileText className="h-4 w-4" />
          Editar Template
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Template de Contrato</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium">Conteúdo do Template</label>
            <Textarea
              value={template}
              onChange={(e) => setTemplate(e.target.value)}
              className="mt-2 min-h-[400px] font-mono text-sm"
              placeholder="Digite o conteúdo do template..."
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button onClick={salvarTemplate} className="bg-primary hover:bg-primary/90">
              <Save className="h-4 w-4 mr-2" />
              Salvar Template
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
